import React, { useEffect, FC } from 'react'
import { connect } from 'react-redux'

import { Form, Input, Button, message } from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons'

import './login.less'


import { useGetRandomCode } from '@/hook/randomCode'
import Base64  from 'base-64';
import axios from '@/axios/axios'
import * as actions from '@/store/actions'
import {Link} from "react-router-dom";


const LoginForm: FC<any> = ({ history, setUserInfo}) => {
    const [randomImgUrl, getRandomImgFn] = useGetRandomCode<string>('')
    // 触发登录方法
    const onFinish = ({userName, password,randomCode }:any): void => {
        login({
            userName: Base64.encode(userName),
            password: Base64.encode(password),
            randomCode: Base64.encode(randomCode),
        });
    }
    const login = async (params: any) => {
        const {code, data, msg}: any = await axios.post('/user/api/continuing/login',params)
        if(code == 0) {
            setUserInfo({userInfo: data || null});
            const path = data.hasPersonInfoFlag ? `/index/home`: `/userInfo`
            history.push(path)
        } else {
            message.error(msg)
            getRandomImgFn()
        }
    }


    useEffect( () => {

    }, [])


    const FormView = (
        <Form className="login-form" name="login-form" onFinish={onFinish}>
            <Form.Item
                name="userName"
                rules={[{ required: true, message: '请输入用户名' }]}
            >
                <Input placeholder="用户名" prefix={<UserOutlined />} size="large" />
            </Form.Item>
            <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码' }]}
            >
                <Input.Password
                    placeholder="密码"
                    prefix={<LockOutlined />}
                    size="large"
                />
            </Form.Item>
            <Form.Item
                name="randomCode"
                rules={[{ required: true, message: '请输入密验证码' }]}
            >
                <Input
                    type="input"
                    placeholder="请输入图形验证码"
                    suffix={<img src={randomImgUrl} alt="code" onClick={() => { getRandomImgFn() }} style={{ width: '100px', height: '100%' }} />}
                />
            </Form.Item>
            <Form.Item>
                <Button
                    className="login-form-button"
                    htmlType="submit"
                    size="large"
                    type="primary"
                >
                    登录
                </Button>
            </Form.Item>
            <Form.Item>
                    <Link style={{float: "left"}} to="/register">注册</Link>
                    <Link style={{float: "right"}} to="/forgot">忘记密码</Link>
            </Form.Item>
            <Form.Item>
                <div style={{textAlign:"center"}}>
                    <p>
                        客服电话: 400-001-8080
                    </p>
                </div>
            </Form.Item>
        </Form>
    )
    return (
        <div className="login-layout" id="login-layout">
            <div className="login-box">
                <div className="logo-name">医视界 | 远程继续医学教育平台</div>
                <div className={"login-form-box"}>
                    {FormView}
                </div>
            </div>
        </div>
    )
}

export default connect(
    (state) => state,
    actions
)(LoginForm)
